export const enum ProductTypes {
	MODULE = 'module',
	BATTERY = 'battery',
	ADDON = 'addon',
	ACCESSORY = 'accessory',
	INVESTER = "invester",
	GENERAL = 'general',
	SURCHARGE="surchage",
	SUBSTRUCTURE="substructure",
	INVIDUAL_OPTION="invidual_option",
	AC_CONNECTION="ac_connection"
}